import React from 'react';
import AdditionalPricesProperties from "./AdditionalPricesProperties";
import {Observer} from "mobx-react-lite";
import AddAdditionalPrice from '../AddAdditionalPrice/AddAdditionalPrice';
import AdditionalPriceRow from '../AdditionalPriceRow/AdditionalPriceRow';
import OrderAdditionalPrice from '../../../../../entities/OrderAdditionalPriceRequest';
import MessageCard from '../../../../../ui_components/MessageCard/MessageCard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import {useI18nContext} from '../../../../../contexts/I18nContext';
import {useStyles} from './AdditionalPrices.style';

const AdditionalPrices: React.FC<AdditionalPricesProperties> = ({
                                                                    store
                                                                }) => {

    const classes = useStyles();
    const i18n = useI18nContext();

    const removeAdditionalPrice = async (additionalPrice: OrderAdditionalPrice) => {
        await store.removeAdditionalPrice(additionalPrice);
    }

    return <Observer>
        {() => (
            <div className={classes.container}>
                <div>
                    <AddAdditionalPrice store={store}/>
                </div>
                {store.additionalPrices.length > 0 && <div className={classes.list_container}>
                    {store.additionalPrices.map((t: any, i: any) => (
                        <AdditionalPriceRow onDelete={removeAdditionalPrice} additionalPrice={t} key={i}/>
                    ))}
                </div>}
                {store.additionalPrices.length === 0 &&
                <div className={classes.no_data_container}>
                    <MessageCard icon={AttachMoneyIcon} title={i18n.translate("NO_ADDITIONAL_PRICE_TITLE")}
                                 subtitle={i18n.translate("NO_ADDITIONAL_PRICE_SUBTITLE")}/>
                </div>
                }

            </div>
        )}
    </Observer>
}

export default AdditionalPrices;
